import { MatDialogRef } from '@angular/material';

export class BaseDialog<DialogComponent> {

  constructor(protected dialogRef: MatDialogRef<DialogComponent>) {}

  cancel() {
    this.dialogRef.close(null);
  }

  accept(comment) {
    this.dialogRef.close(comment);
  }

}
